import React from 'react';
import { trackPage, PageType } from '../../helpers/tracking';
import { RouteProps } from 'react-router-dom';

const withTracker = <P extends RouteProps>(
  WrappedComponent: React.ComponentType<P>,
  pageType: PageType,
) => {
  const HOC = class extends React.Component<P> {
    componentDidMount() {
      if (!Boolean(this.props.location)) {
        return;
      }
      const page = this.props.location!.pathname;
      trackPage(page, pageType);
    }

    componentWillReceiveProps(nextProps: P) {
      if (!Boolean(this.props.location) || !Boolean(nextProps.location)) {
        return;
      }
      const currentPage = this.props.location!.pathname;
      const nextPage = nextProps.location!.pathname;

      if (currentPage !== nextPage) {
        trackPage(nextPage, pageType);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

  return HOC;
};

export default withTracker;
